export const DEFAULT_TITLE = 'Silogues';

export const handleMetadata = (to, from, next) => {
  document.title = to.meta.title ?? DEFAULT_TITLE;
  next();
};
